import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import StatusCheck from "@/components/landing/StatusCheck";
import FormSection from "@/components/landing/FormSection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Kobi-Line | Ücretsiz Ön Analiz Formu";
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FAF9F6] text-[#0F172A] font-body antialiased overflow-x-hidden">
      <Navbar />
      <Hero />
      <Marquee />
      <Chapters />
      <StatusCheck />
      <FormSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
